import React from 'react'
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import { ItemIcon, ItemText, StatistiqueItem } from './Style';

export default function Statistiuqe(props) {
    return (
        <ScrollAnimation animateIn="animate__fadeIn">
            <StatistiqueItem>
                <ItemIcon>
                    <img src={props.image} />
                </ItemIcon>
                <ItemText>
                    <h5>{props.number} +</h5>
                    <h4>{props.title}</h4>
                </ItemText>
            </StatistiqueItem>
        </ScrollAnimation>
    )
}
